<template>
    <div class="container mx-auto page no-top-bar">
        <TopBarDetail
            :isShowBack="true"
            :isShowFavorite="false"
            :isShowShare="false"
            @clickBack="clickBack()"
        ></TopBarDetail>
        <div>
            <NotiList
                :modalController="modalController">
            </NotiList>
        </div>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>

</template>
<script>
//component
import TopBarDetail from '@/components/Layout/TopBar/TopBarDetail.vue';
import NotiList from "../component/NotiList.vue";
//mixin
import ModalMixin from "@/mixin/ModalMixin.js";

export default {
    name: 'notificationlist',
    mixins: [ModalMixin],
    components: {
        TopBarDetail,
        NotiList,
    },
    methods: {
        clickBack: function () {
            this.$router.back();
        }
    }
}
</script>
